import React, { useEffect } from 'react';
import { Icon } from './Icons';

export default function ConfirmDialog({ title, message, onConfirm, onCancel, danger = true }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onCancel?.();
      if (e.key === 'Enter') onConfirm?.();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onConfirm, onCancel]);

  return (
    <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>
      <div className="modal-box confirm-dialog-box" role="dialog" aria-modal="true">
        <div className="modal-header">
          <div className="modal-header-title-group">
            <div className={`modal-header-icon ${danger ? 'danger' : 'info'}`}>
              <Icon name={danger ? 'trash' : 'check'} size={18} />
            </div>
            <h2 className="modal-title">{title}</h2>
          </div>
          <button type="button" className="btn-icon" onClick={onCancel} aria-label="Cancel">
            <Icon name="close" size={18} />
          </button>
        </div>

        <div className="modal-body">
          <p className="confirm-message">{message}</p>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-ghost" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className={danger ? 'btn-danger-custom' : 'btn-primary-custom'}
            onClick={onConfirm}
            autoFocus
          >
            <Icon name={danger ? 'trash' : 'check'} size={15} />
            <span>{danger ? 'Delete' : 'Confirm'}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
